














import Vue from 'vue';
import PageHeader from '@/components/PageHeader.vue';
import Users from '@/components/Users.vue';

export default Vue.extend({
  name: 'Scuole' as string,

  components: {
    PageHeader,
    Users,
  },

  data: () => ({
    breadcrumbs: [
      {
        text: 'Utenti',
        exact: true,
        to: { name: 'Utenti' },
      },
    ],

    dialog: false,
  }),
});
